var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeoff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "body_1",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.6666667 0 0 2.6666667 0 0)"
  }, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.83 9.17999C 14.2706 8.61995 13.5576 8.23846 12.7813 8.08386C 12.0049 7.92926 11.2002 8.00851 10.4689 8.31152C 9.73758 8.61453 9.11264 9.12769 8.67316 9.78607C 8.23367 10.4444 7.99938 11.2184 8 12.01C 7.99916 13.0663 8.41619 14.08 9.16004 14.83",
    stroke: "#EBEBEB",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.01C 13.0609 16.01 14.0783 15.5886 14.8284 14.8384C 15.5786 14.0883 16 13.0709 16 12.01",
    stroke: "#EBEBEB",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.61 6.39004L6.38 17.62C 4.6208 15.9966 3.14099 14.0944 2 11.99C 6.71 3.76002 12.44 1.89004 17.61 6.39004z",
    stroke: "#EBEBEB",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9994 3L17.6094 6.39",
    stroke: "#EBEBEB",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38 17.62L3 21",
    stroke: "#EBEBEB",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5695 8.42999C 20.4801 9.55186 21.2931 10.7496 21.9995 12.01C 17.9995 19.01 13.2695 21.4 8.76953 19.23",
    stroke: "#EBEBEB",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeoff);
export default __webpack_public_path__ + "static/media/eyeoff.8ba212e060e9f3a9d89aa86d59501882.svg";
export { ForwardRef as ReactComponent };